import { Level2, Level3 } from '../StyledOl';

const Definitions = () => (
  <li>
    DEFINITIONS
    <Level2>
      <li>
        In these&nbsp;Terms and Conditions unless the context otherwise requires:
        <Level3>
          <li>
            &ldquo;<strong>Affiliates</strong>&rdquo; means with respect to any entity, any other
            entity controlling, controlled by or under common control with such entity. For the
            purpose of this definition, &ldquo;control&rdquo; (including the terms
            &ldquo;controlling&rdquo;, &ldquo;controlled by&rdquo; and &ldquo;under common control
            with&rdquo;) means the possession, direct or indirect, of the power to direct or cause
            the direction of the management and policies of an entity, whether through the ownership
            of voting securities, by contract or otherwise;
          </li>
          <li>
            &ldquo;<strong>Bill of Lading</strong>&rdquo; means a detailed list of Documentations or
            a shipment of goods in form of a receipt given by the Contractor to LINK;
          </li>
          <li>
            &ldquo;<strong>Contractor</strong>&rdquo; means the contractor who has been engaged by
            LINK to supply the Goods and/or Services;
          </li>
          <li>
            &ldquo;<strong>Documentation</strong>&rdquo; means any documents provided by the
            Contractor in relation to the Goods or Services rendered to LINK;
          </li>
          <li>
            &ldquo;<strong>Goods</strong>&rdquo; means the product, goods, or items which are the
            subject matter of this Purchase Order;
          </li>
          <li>
            &ldquo;<strong>LINK</strong>&rdquo; means NTUC Link Private Limited or any of its
            affiliated organizations as listed in the Purchase Order;
          </li>
          <li>
            &ldquo;<strong>LINK Information</strong>&rdquo; means all information, in any form,
            disclosed, furnished or made available directly or indirectly to Contractor and/or its
            subcontractors by or on behalf of LINK or otherwise received or obtained by Contractor
            and/or its subcontractors pursuant to, by virtue of, or in the course of negotiating or
            performing this Purchase Order, including (i) all information relating to the customers
            of LINK; (ii) all Personal Data; and (iii) all communications between the Parties
            relating to the aforesaid.
          </li>
          <li>
            &ldquo;<strong>Parties</strong>&rdquo; or &ldquo;
            <strong>Party</strong>&rdquo; means LINK and the Contractor or each of them as the case
            may be;
          </li>
          <li>
            &ldquo;<strong>person</strong>&rdquo; includes a corporation or an incorporated
            association;
          </li>
          <li>
            &ldquo;<strong>Personal Data</strong>&rdquo; means data, whether true or not, about an
            individual which can be identified (i) from the data or a combination of different data;
            and (ii) from the data and other information to which the Contractor has or is likely to
            have access.
          </li>
          <li>
            &ldquo;<strong>Purchase Order</strong>&rdquo; includes these Terms and Conditions for
            Purchase of Goods and/or Services, Specifications and any statements of work issued by
            LINK to the Contractor or agreed by LINK with the Contractor for the supply of the Goods
            and/or Services;
          </li>
          <li>
            &ldquo;<strong>Services</strong>&rdquo; means the work and services which the Contractor
            is required to perform under the Purchase Order as set out in the Specifications, and
            includes the fulfilment and delivery of any and all services deliverables set out in the
            Specifications;
          </li>
          <li>
            &ldquo;<strong>Specifications</strong>&rdquo; means the specifications relating to the
            Services and/or Goods issued by LINK to the Contractor or agreed by LINK with the
            Contractor, to which these Terms and Conditions are attached;
          </li>
          <li>
            &ldquo;<strong>Site</strong>&rdquo; means LINK&rsquo;s office location(s) as
            communicated to the Contractor or such other address(es) as LINK may substitute by
            giving notice to the Contractor in writing;
          </li>
          <li>
            &ldquo;<strong>Third Party</strong>&rdquo; means any person who is not a Party to this
            Purchase Order;
          </li>
          <li>
            &ldquo;<strong>Warranty Period</strong>&rdquo; means the warranty period as stated in
            the Purchase Order and as described in clause 13, if applicable;
          </li>
        </Level3>
      </li>
    </Level2>
  </li>
);

export default Definitions;
